import React, { useState, useEffect } from "react";
import api from "../../utils/axiosConfig";
import { useNavigate } from "react-router-dom";
import { FaTrashAlt } from "react-icons/fa";
import { motion } from "framer-motion";
import { toast } from "react-toastify";

const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5000";

export default function ClearCart({ onCartCleared }) {
  const navigate = useNavigate();
  const [isClearing, setIsClearing] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleClearCart = async () => {
    setIsClearing(true);
    try {
              await api.delete(`/api/shop/cart/clear`, {
        withCredentials: true,
      });
      
      toast.success("Panier vidé avec succès !", {
        onClick: () => navigate('/cart'),
        style: { cursor: 'pointer' }
      });
      
      if (onCartCleared) {
        onCartCleared();
      }
      
    } catch (err) {
      console.error("Erreur lors du vidage du panier:", err);
      toast.error("Erreur lors du vidage du panier.");
    } finally {
      setIsClearing(false);
    }
  };

  const handleClearClick = () => {
    const isConfirmed = window.confirm("Êtes-vous sûr de vouloir vider complètement votre panier ? Cette action est irréversible et restaurera le stock de tous les produits.");
    
    if (isConfirmed) {
      handleClearCart();
    }
  };

  return (
    <>
      <motion.button
        onClick={handleClearClick}
        whileHover={{ scale: 1.05, y: -2 }}
        whileTap={{ scale: 0.95 }}
        style={{
          padding: isMobile ? "8px 12px" : "10px 16px",
          backgroundColor: "rgba(220, 53, 69, 0.1)",
          backdropFilter: "blur(20px)",
          color: "#dc3545",
          border: "1px solid rgba(220, 53, 69, 0.3)",
          borderRadius: "12px",
          cursor: "pointer",
          fontSize: isMobile ? "12px" : "14px",
          fontWeight: "500",
          display: "flex",
          alignItems: "center",
          gap: isMobile ? "6px" : "8px",
          minWidth: "fit-content",
          maxWidth: isMobile ? "120px" : "none",
          fontFamily: "'Cormorant Garamond', serif",
          boxShadow: "0 4px 15px rgba(220, 53, 69, 0.1)",
          transition: "all 0.3s ease",
          position: "relative",
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        }}
      >
        <FaTrashAlt style={{ fontSize: isMobile ? "12px" : "14px", flexShrink: 0 }} />
        <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
          {isMobile ? "Vider" : "Vider le Panier"}
        </span>
      </motion.button>
    </>
  );
}
